module.exports = __webpack_public_path__ + "static/media/logo-internal-retina.8e255c50.png";